import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/memberRole';
import { fetchRequest as fetchMembers } from '../../actions/organizations/members';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  const { orgId, userId, role } = action.payload;
  try {
    yield call(
      axios.put,
      `${config.API_URL}/organization/${orgId}/members/${userId}/role`,
      { role },
      { headers: getLocalUser() },
    );
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Role updated' });
    yield put(fetchSuccess({ userId, role }));
    yield put(fetchMembers({ orgId }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message || 'Could not update role';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  // takeEvery: role changes on different rows may be dispatched in
  // parallel and must all run.
  yield takeEvery(REQUEST, operation);
}
